export default __webpack_public_path__ + "static/media/loyality.b9f14986.svg";